import script from "./StickerSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./StickerSelector.vue?vue&type=script&setup=true&lang=js"

import "./StickerSelector.vue?vue&type=style&index=0&id=67f981f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67f981f2"]])

export default __exports__